import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import Video from '../video'

import styles from './intro.module.scss'

const Intro = () => (
  <div className={styles.root}>
    <div className={styles.outer}>
      <div className={styles.inner}>
        <div className={styles.heading}>
          <FormattedHTMLMessage defaultMessage="Funktioner du kommer älska" id="billing.intro.heading" tagName="h2" />
        </div>
        <div className={styles.description}>
          <FormattedHTMLMessage
            defaultMessage="Fullskaligt faktureringsprogram som gör det enkelt att få betalt. Fyllt med funktioner som ofta kostar extra, helt gratis med Dooer."
            id="billing.intro.lede"
            tagName="p"
          />
        </div>
        <Video />
      </div>
    </div>
  </div>
)

export default Intro
